(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1439px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Mega Menu Handler - Div-based with proper animations
  class MegaMenuHandler {
    constructor() {
      this.menus = document.querySelectorAll('.mega-menu');
      this.activeMenu = null;
      this.init();
    }

    init() {
      this.menus.forEach(menu => {
        const trigger = menu.querySelector('.mega-menu__trigger');
        const content = menu.querySelector('.mega-menu__content');
        
        if (!trigger || !content) return;
        
        // Click handler for trigger button
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleMenu(menu);
        });
      });
      
      // Close menus when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mega-menu')) {
          this.closeAllMenus();
        }
      });
      
      // Handle escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllMenus();
        }
      });
    }
    
    toggleMenu(menu) {
      const isOpen = menu.classList.contains('open');
      
      if (isOpen) {
        this.closeMenu(menu);
      } else {
        this.openMenu(menu);
      }
    }
    
    openMenu(menu) {
      // Close any other open menu first
      if (this.activeMenu && this.activeMenu !== menu) {
        this.closeMenu(this.activeMenu);
      }
      
      // Open this menu
      menu.classList.add('open');
      const trigger = menu.querySelector('.mega-menu__trigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
      
      // Update active menu
      this.activeMenu = menu;
      
      // Ensure header stays solid
      const stickyHeader = document.querySelector('sticky-header');
      if (stickyHeader) {
        stickyHeader.classList.add('menu-open');
      }
      document.body.classList.add('mega-menu-open');
    }
    
    closeMenu(menu) {
      menu.classList.remove('open');
      const trigger = menu.querySelector('.mega-menu__trigger');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      
      // Clear active menu if it's the one being closed
      if (this.activeMenu === menu) {
        this.activeMenu = null;
      }
      
      // Remove solid header if no menus are open
      if (!this.activeMenu) {
        const stickyHeader = document.querySelector('sticky-header');
        if (stickyHeader) {
          stickyHeader.classList.remove('menu-open');
        }
        document.body.classList.remove('mega-menu-open');
      }
    }
    
    closeAllMenus() {
      this.menus.forEach(menu => {
        this.closeMenu(menu);
      });
      this.activeMenu = null;
    }
  }
  
  // Initialize mega menu handler when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new MegaMenuHandler();
    });
  } else {
    new MegaMenuHandler();
  }
  
  // Mobile menu overlay click to close
  document.addEventListener('click', function(e) {
    const menuDrawer = document.querySelector('#menu-drawer');
    const menuDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (menuDrawer && menuDetails && menuDetails.open) {
      // Check if click is on the drawer background (not on drawer content)
      if (e.target === menuDrawer || e.target.classList.contains('menu-drawer__inner-container')) {
        menuDetails.open = false;
        menuDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
        document.body.classList.remove('overflow-hidden-tablet');
      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
